import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  stationRevenueTrend: [],
  loading: false,
  error: null,
};

const stationRevenueTrendSlice = createSlice({
  name: "stationRevenueTrend",
  initialState,
  reducers: {
    fetchStationRevenueTrendSuccess: (state, action) => {
      state.loading = false;
      state.stationRevenueTrend = action.payload;
    },
    fetchStationRevenueTrendFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchStationRevenueTrendSuccess, fetchStationRevenueTrendFailure } =
  stationRevenueTrendSlice.actions;

export default stationRevenueTrendSlice.reducer;
